"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles = {
    root: {
        width: "100%",
        zIndex: 130,
        position: "relative",
    },
    controls: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        height: "fit-content",
        gap: "0.25rem",
        alignItems: "center",
        backgroundColor: "#ffffff",
        opacity: 1,
        padding: "0.5rem",
        border: "1px solid #D0D5DD",
        borderRadius: "0 0 7px 7px",
        // Allow buttons that are children of the"video-controls div to not be hidden by the encoder video
        "& button": {
            display: "block",
        },
        "&.video-controls--hidden": {
            opacity: 0,
            transitionDelay: "500ms",
        },
        "&.lv-controls--hidden": {
            opacity: 0,
            transitionDelay: "500ms",
        },
    },
    // @todo: remove this in future.
    // Currently this is a back up in case a video element has it's controls.
    "video::-webkit-media-controls": {
        display: "none!important",
        "-webkit-appearance": "none",
    },
    "video::-moz-media-controls": {
        display: "none!important",
        "-webkit-appearance": "none",
    },
};
exports.default = styles;
//# sourceMappingURL=styles.js.map